import BooleanController from "csi/heading/BooleanController";
import locale from "csi/locale";
import MessageDialog from "csi/widget/MessageDialog";
import declare from "dojo/_base/declare";

const SetShapeMasterAllSeasons = declare(BooleanController, {
    
	process() {
		const isAllSeasons = this._getCheckboxValue();
		if (isAllSeasons) {
			this.confirmAction({
				materialIcon: MessageDialog.ICON_WARNING,
				buttons: [MessageDialog.BUTTON_CONTINUE, MessageDialog.BUTTON_CANCEL],
				title: locale.resource("ConvertToAllSeasons"),
				message: locale.typeAction("ShapeMaster", "SetShapeMasterAllSeasons_Confirm"),
				onResponse: (key: string) => {
					if (key == MessageDialog.BUTTON_CONTINUE) {
						BooleanController.prototype.process.call(this);
					} else {
						this.postProcess();
					}
				},
			});
		}
		else {
			BooleanController.prototype.process.call(this);
		}
	},
		

});

export = SetShapeMasterAllSeasons;